import { useEffect, useState } from 'react'
import OrgInput, { TaskCtrlDomain } from '../../components/input/OrgInput'
import { getMiroBoardInfo, getMiroUserInfo } from '../../util/info'
import MiroTokenManager from '../../service/MiroTokenManager'
import logo from 'src/assets/logo.png'

const LoginPage = () => {
  const tokenManager = MiroTokenManager.getInstance()
  const [subdomain, setSubdomain] = useState<string>()
  const [domain, setDomain] = useState<TaskCtrlDomain>('taskctrl.io')
  const [email, setEmail] = useState<string>()
  const [boardId, setBoardId] = useState<string>()
  const [refreshBool, setRefresh] = useState(false)
  const workspaceHost = subdomain
    ? `${subdomain}.${domain}`
    : `your-org.${domain}`

  useEffect(() => {
    getMiroBoardInfo().then((info) => {
      setBoardId(info?.id)
    })
    getMiroUserInfo().then((info) => {
      setEmail(info?.email)
    })
  }, [])

  const onClick = async () => {
    localStorage.setItem('workspaceHost', workspaceHost)
    const token = await tokenManager.getToken()
    const host = window.location.href.split('?')[0]
    const taskCtrlUrl =
      import.meta.env.DEV && subdomain === 'localhost'
        ? 'http://localhost:3000'
        : `https://${workspaceHost}`
    window.open(
      `${taskCtrlUrl}/miro?boardId=${boardId}&returnUrl=${host}&token=${token}&miroUserEmail=${email}`,
      '_blank',
    )
    setRefresh(true)
  }

  const refresh = () => {
    window.location.reload()
  }

  return (
    <div className="flex w-full h-full justify-center items-center px-4 py-4">
      <div className="w-full max-w-md px-2 py-2 flex flex-col gap-4">
        <div className="flex flex-col gap-3">
          <img src={logo} alt="taskCtrl-logo" className="max-w-[170px]" />
          <h1>Connect Miro with TaskCtrl</h1>
        </div>

        <div className="flex flex-col gap-3">
          <OrgInput
            onChange={setSubdomain}
            domain={domain}
            onDomainChange={setDomain}
          />
          <p className="status-text">
            Opening:{' '}
            <span className="font-semibold">https://{workspaceHost}/miro</span>
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <p className="status-text">
            Not sure? Check your TaskCtrl address bar. Example: acme.taskctrl.io
            {' → enter '}
            <span className="font-semibold">acme</span> and choose{' '}
            <span className="font-semibold">taskctrl.io</span>.
          </p>
          <button
            onClick={refreshBool ? refresh : onClick}
            className={`button button-primary text-center flex justify-center w-full`}
            disabled={!subdomain}
          >
            {refreshBool ? 'Refresh' : 'Connect'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default LoginPage
